export default __webpack_public_path__ + "static/micro-43d266e5393eef7cd3852171674dc7f0.png";